import script from "./AppHeaderCommunityDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppHeaderCommunityDetails.vue?vue&type=script&setup=true&lang=ts"

import "./AppHeaderCommunityDetails.vue?vue&type=style&index=0&id=2d00209f&lang=scss"

const __exports__ = script;

export default __exports__